import React, {useEffect, useState} from "react";
import Box from '../../../../components/box/Box';
import TableVirtualized from "../../../../components/virtualized/virtualized";
import http from "../../../../components/plugins/axios";
import {makeUrl} from "../../../../util/BuyersSellersUtil";

export default function TableService({sectors, byValue, byGics, lastUpdate, callBack}) {
    const [data, setData] = useState(null);
    const [sector, setSector] = useState();
    const [intervalId, setIntervalId] = useState(null);
    // const dispatch = useDispatch();
    // const {currentState} = useSelector(
    //     (state) => ({currentState: state.buyersSellers}),
    //     shallowEqual
    // );
    // const {tableData, sectors, byGics, byValue, sector} = currentState;
    const [columns] = useState([
        {
            title: "نماد",
            dataIndex: "symbol",
            sorter: true,
            type: 'link',
            checkbox: false,
            enable: true,
        },
        {
            title: "خرید حقوقی",
            dataIndex: "companiesBuy",
            sorter: true,
            checkbox: false,
            enable: true,
        },
        {
            title: "فروش حقوقی",
            dataIndex: "companiesSell",
            sorter: true,
            checkbox: false,
            enable: true,
        },
        {
            title: "خرید حقیقی",
            dataIndex: "individualsBuy",
            sorter: true,
            checkbox: false,
            enable: true,
        },
        {
            title: "فروش حقیقی",
            dataIndex: "individualsSell",
            sorter: true,
            checkbox: false,
            enable: true,
        },
    ]);


    useEffect(() => {
        callTableAPI('بانک')        // if (!sector) dispatch(buyersSellersSlice.actions.changeSector(undefined))
    }, [])

    function callTableAPI(sector, byValue = false, byGics = false) {
        setSector(sector)
        http
            .get(makeUrl(sector, byValue, byGics))
            .then((response) => {
                setData(response.data.data)
            })
            .catch((error) => {
                console.log(error)
            });
    }

    function changeSector() {
        return sectors[Math.floor(Math.random() * sectors.length)]
    }

    // useEffect(() => {
    //     setSector(changeSector())
    // }, [sectors, byGics])

    function dropDownHandler(sector) {
        callTableAPI(sector, byValue, byGics)
    }

    function handleSwitchValueVolume(byValue) {
        callBack(byValue, byGics)
        if (sector) callTableAPI(sector, byValue, byGics)
    }

    function handleSwitchSectorGICS(byGics) {
        callBack(byValue, !byGics)
        if (!byGics) callTableAPI('امور مالی', byValue, true)
        else callTableAPI('بانک', byValue)
    }

    const properties = {
        lastUpdate: lastUpdate,
        sectors: sectors,
        dropDownHandler: dropDownHandler,
        switchValueVolume: true,
        dropDownInputPlace: 'گروه',
        dropDownIconClassName: 'fa-industry',
        switchGics: true,
        disableLiveCircle: true,
        onLabel: "ارزش",
        offLabel: "حجم",
        handleSwitchValueVolume: handleSwitchValueVolume,
        handleSwitchSectorGICS: handleSwitchSectorGICS,
        help: {
            title: 'حقیقی و حقوقی',
            content: `با انتخاب یک گروه می توانید میزان خرید/ فروش حقیقی و حقوقی را مشاهده کنید.
        `
        }
    };

    const tooltipSteps = [
        {
            target: '.extraGicsToggle',
            content: 'دسته بندی استاندارد جهانی',
            placement: 'right',
        },
        {
            target: '.extraValueVolumeToggle',
            content: 'فیلتر بر اساس حجم یا ارزش معاملات',
        },
        {
            target: '.extraDropDown',
            content: 'انتخاب گروه یا صنعت',
        },
        {
            target: '.extra-last-update',
            content: 'زمان دقیق به روز رسانی',
        },
    ]

    return (
        <div style={{marginTop: '23px'}}>
            <Box uiActions={properties} title={sector} loaded={sectors} tooltipSteps={tooltipSteps}
                 disableHeaderAdBox={true}
                 showRW={true}
                 linksMap={{
                     'last': 'بازار بورس',
                 }}>
                {data && sectors && sector &&
                <TableVirtualized
                    columns={columns}
                    mutableData={data}
                    defaultSortBy={'individualsBuy'}
                    defaultSortDirection={'DESC'}
                    keyField="symbol"
                    numberFormat={true}
                />
                }
            </Box>
        </div>
    )
}